// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_exn from "../../../node_modules/rescript/lib/es6/js_exn.js";
import * as Sentry from "../sentry/Sentry.bs.js";
import * as Belt_Option from "../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Network$Catalyst from "../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as Caml_js_exceptions from "../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as NetworkV2$Catalyst from "../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as PromiseHandler$Catalyst from "../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/PromiseHandler.bs.js";

function getHostAndPath(url) {
  try {
    var parsed = new URL(url);
    return [
            parsed.origin,
            parsed.pathname
          ];
  }
  catch (exn){
    return [
            "unknown",
            "unknown"
          ];
  }
}

function getStatusCode(response) {
  if (typeof response === "number") {
    switch (response) {
      case /* RequestTimeout */0 :
          return "Timeout";
      case /* FailedToFetch */1 :
          return "FailedToFetch";
      case /* RequestCancelled */2 :
          return "RequestCancelled";
      case /* OperationAborted */3 :
          return "OperationAborted";
      
    }
  } else {
    switch (response.TAG | 0) {
      case /* Success */0 :
      case /* SuccessWithNoContent */1 :
          return "Success";
      case /* UnprocessedEntity */2 :
          return "422";
      case /* NotAcceptableEntity */3 :
          return "406";
      case /* Unauthorized */4 :
          return "401";
      case /* Forbidden */5 :
          return "403";
      case /* InternalServerError */6 :
          return "5xx_or_unmapped";
      case /* DataConflict */7 :
          return "409";
      case /* Cors */8 :
          return "CORS";
      case /* UnhandledError */9 :
          return "UnhandledError";
      
    }
  }
}

function captureSentryException(httpMethod, requestUrl, maskedApiRoute, response) {
  var match = getHostAndPath(requestUrl);
  var route = Belt_Option.getWithDefault(maskedApiRoute, match[1]);
  var statusCode = getStatusCode(response);
  var tags = {
    error_kind: "API_ERROR",
    type: "API_ERROR",
    caught_by: "CrmNetwork",
    api_status_code: statusCode,
    api_method: httpMethod,
    api_url: route,
    api_host: match[0]
  };
  if (typeof response !== "number" && response.TAG === /* UnhandledError */9) {
    return Sentry.captureException(undefined, Caml_option.some(tags), response._0);
  }
  return Sentry.captureException(undefined, Caml_option.some(tags), Sentry.makeError(httpMethod + " " + route + " " + statusCode, statusCode));
}

function captureErrorIfApplicable(httpMethod, requestUrl, maskedApiRoute, response) {
  try {
    if (typeof response === "number") {
      switch (response) {
        case /* RequestCancelled */2 :
        case /* OperationAborted */3 :
            break;
        default:
          captureSentryException(httpMethod, requestUrl, maskedApiRoute, response);
      }
    } else {
      switch (response.TAG | 0) {
        case /* Success */0 :
        case /* SuccessWithNoContent */1 :
            break;
        default:
          captureSentryException(httpMethod, requestUrl, maskedApiRoute, response);
      }
    }
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    var detail = exn.RE_EXN_ID === Js_exn.$$Error ? Belt_Option.getWithDefault(exn._1.message, "Unknown error while reporting API failure") : "Non-JS exception while reporting API failure";
    Sentry.captureMessage(undefined, {
          error_kind: "TELEMETRY_FAILURE",
          caught_by: "CrmNetwork"
        }, detail);
  }
  return response;
}

function withReporting(promise, httpMethod, requestUrl, maskedApiRoute) {
  console.log("Log method and req url: ", httpMethod, requestUrl);
  return promise.then(function (response) {
              return Promise.resolve(captureErrorIfApplicable(httpMethod, requestUrl, maskedApiRoute, response));
            });
}

function get(requestUrl, maskedApiRoute, headers, timeoutMsOpt, retryCountOpt, credentialsOpt, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : NetworkV2$Catalyst.maxTimeoutMs;
  var retryCount = retryCountOpt !== undefined ? retryCountOpt : NetworkV2$Catalyst.maxRetryCount;
  var credentials = credentialsOpt !== undefined ? credentialsOpt : /* SameOrigin */1;
  return withReporting(NetworkV2$Catalyst.get(requestUrl, headers, timeoutMs, retryCount, credentials, undefined), "GET", requestUrl, maskedApiRoute);
}

function post(requestUrl, maskedApiRoute, headers, payload, timeoutMsOpt, credentialsOpt, formData, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : NetworkV2$Catalyst.maxTimeoutMs;
  var credentials = credentialsOpt !== undefined ? credentialsOpt : /* SameOrigin */1;
  return withReporting(NetworkV2$Catalyst.post(requestUrl, headers, payload, timeoutMs, credentials, formData, undefined), "POST", requestUrl, maskedApiRoute);
}

function postV2(requestUrl, maskedApiRoute, headers, payload, timeoutMsOpt, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : NetworkV2$Catalyst.maxTimeoutMs;
  return withReporting(NetworkV2$Catalyst.postV2(requestUrl, headers, payload, timeoutMs, undefined), "POST", requestUrl, maskedApiRoute);
}

function put(requestUrl, maskedApiRoute, headers, payload, timeoutMsOpt, credentialsOpt, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : NetworkV2$Catalyst.maxTimeoutMs;
  var credentials = credentialsOpt !== undefined ? credentialsOpt : /* SameOrigin */1;
  return withReporting(NetworkV2$Catalyst.put(requestUrl, headers, payload, timeoutMs, credentials, undefined), "PUT", requestUrl, maskedApiRoute);
}

function $$delete(requestUrl, maskedApiRoute, headers, timeoutMsOpt, retryCountOpt, credentialsOpt, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : NetworkV2$Catalyst.maxTimeoutMs;
  var retryCount = retryCountOpt !== undefined ? retryCountOpt : NetworkV2$Catalyst.maxRetryCount;
  var credentials = credentialsOpt !== undefined ? credentialsOpt : /* SameOrigin */1;
  return withReporting(NetworkV2$Catalyst.$$delete(requestUrl, headers, timeoutMs, retryCount, credentials, undefined), "DELETE", requestUrl, maskedApiRoute);
}

function postRequestV2(requestUrl, maskedApiRoute, payload, header, timeoutMsOpt, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : Network$Catalyst.maxTimeoutMs;
  return withReporting(Network$Catalyst.postRequestV2(requestUrl, payload, header, timeoutMs, undefined), "POST", requestUrl, maskedApiRoute);
}

function resolvePromise(promise, timeoutMsOpt, requestUrl, maskedApiRoute, httpMethod, param) {
  var timeoutMs = timeoutMsOpt !== undefined ? timeoutMsOpt : NetworkV2$Catalyst.maxTimeoutMs;
  return withReporting(PromiseHandler$Catalyst.PromiseHandler.resolvePromise(promise, timeoutMs, requestUrl), httpMethod, requestUrl, maskedApiRoute);
}

var maxTimeoutMs = NetworkV2$Catalyst.maxTimeoutMs;

var maxRetryCount = NetworkV2$Catalyst.maxRetryCount;

export {
  maxTimeoutMs ,
  maxRetryCount ,
  getHostAndPath ,
  getStatusCode ,
  captureSentryException ,
  captureErrorIfApplicable ,
  withReporting ,
  get ,
  post ,
  postV2 ,
  put ,
  $$delete ,
  postRequestV2 ,
  resolvePromise ,
  
}
/* Sentry Not a pure module */
